import { MortarPestlePlusIcon } from './MortarPestlePlusIcon';

/**
 * author: Google
 * id 71BD315A-B0C1-4B8B-93CB-2A952C3A7C16
 * name mortar-pestle-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mortar-pestle-plus.svg
 * tags
 * - Medical / Hospital 
 */
export const ChemistIcon = MortarPestlePlusIcon;
export default ChemistIcon